// extracted by mini-css-extract-plugin
export default {"cls1":"ReportsPage-IconButton_cls1__YtKiw","cls2":"ReportsPage-IconButton_cls2__Hf2OA ReportsPage-IconButton_cls1__YtKiw"};